import $ from 'jquery'
import algoliasearch from 'algoliasearch/lite'
import instantsearch from 'instantsearch.js'
import { highlight } from 'instantsearch.js/es/helpers'
import { configure, index, menu } from 'instantsearch.js/es/widgets'
import { history } from 'instantsearch.js/es/lib/routers'
import { connectSearchBox, connectMenu } from 'instantsearch.js/es/connectors'
import { connectHits } from 'instantsearch.js/es/connectors'
import {
  algoliaAppId,
  algoliaApiKey,
  placeSearchIndex,
  placeSearchSuggestionsIndex,
  locationSearchIndex,
  locationSearchSuggestionsIndex,
} from '../variables'
import { place, noResult, allPlaces } from '../templates'
import {lockBody, unlockBody} from '../utils';
import {createHomeArchiveUrl} from "./home";
import {createArchiveUrl, headerSearch} from "../headers/navbar";

// eslint-disable-next-line no-undef
const { __ } = wp.i18n

// eslint-disable-next-line no-undef
const object = vnObject

const searchClient = algoliasearch(algoliaAppId, algoliaApiKey);
const searchIndex = searchClient.initIndex(placeSearchIndex);


var currentCategory;

const landingHeaderSearch = instantsearch({
  future: {
    preserveSharedStateOnUnmount: true,
  },
  indexName: placeSearchIndex,
  searchClient,
  insights: true,
  routing: {
    router: history({
      cleanUrlOnDispose: false,
      push(url) {
        var queryString = url.split('?')[1];
        var params = new URLSearchParams(queryString);
        var result = '?' + params.toString();
        createLandingArchiveUrl(result)
      },
    }),
  },
})

const placeItem = ({ hits, sendEvent, widgetParams }) => {
  const container = document.querySelector(widgetParams.container)

  var finalUrl = createLandingArchiveUrl('')

  container.innerHTML = `
      ${
      hits.length
          ? hits.map((item) => place(item, highlight)).join('')
          : noResult
  }
      ${`<a href="${finalUrl}" data-orig-href="${
      object.placesPage
  }" class="all-places">
      <span class="all-places__title">${__('See all', 'vn')}</span>
      <span class="all-places__icon"><i class="vn-icons-arrow_circle_right"></i></span>
      </a>`}

  `

  container
    .querySelectorAll('.feed-place__wrapper')
    .forEach((element, index) => {
      element.addEventListener('click', (event) => {
        sendEvent('click', hits[index], 'Place Clicked')
      })
    })
}

const suggestionItem = ({ widgetParams, hits }) => {
  const container = document.querySelector(widgetParams.container)

  container.innerHTML = `<ul>
    ${hits
      .map((hit) => {
        return `
          <li><a href="${
            object.placesPage
          }?${placeSearchIndex}${encodeURI(`[query]=${hit.query}`)}"><i class="vn-icons-restart"></i>
            <span class="hit-text">${hit._highlightResult.query.value}</span>
          <i class="vn-icons-close"></i></a></li>
          `
      })
      .join('')}
  </ul>`
}

const locationItem = ({ widgetParams, hits }) => {
  const container = document.querySelector(widgetParams.container)

  container.innerHTML = `<ul>
    ${hits
      .map((hit) => {
        return `
          <li><a href="${hit.url}"><i class="vn-icons-explore"></i>
            <span class="hit-text">${hit.title}</span>
          <i class="vn-icons-back"></i></a></li>
          `
      })
      .join('')}
  </ul>`
}

const placeSmallItem = ({ widgetParams, hits }) => {
  const container = document.querySelector(widgetParams.container)

  container.innerHTML = `<ul>
    ${hits
      .map((hit) => {
        return `
          <li><a href="${hit.url}"><i class="vn-icons-adjust"></i>
            <span class="hit-text">${hit.title}</span>
          <i class="vn-icons-back"></i></a></li>
          `
      })
      .join('')}
  </ul>`
}

const suggestionItems = connectHits(suggestionItem)

const placeItems = connectHits(placeItem)

const locationItems = connectHits(locationItem)

const placeSmallItems = connectHits(placeSmallItem)

const renderSearchBox = (renderOptions, isFirstRender) => {
  const { query, refine, clear, isSearchStalled, widgetParams } = renderOptions
  const container = document.querySelector(widgetParams.container)

  if (isFirstRender) {
    const input = document.createElement('input')
    input.type = 'search'
    input.placeholder = widgetParams.placeholder

    const navigation = document.createElement('button')
    navigation.insertAdjacentHTML('beforeend', '<i class="vn-icons-navigation"></i>')


    container.insertAdjacentHTML('beforeend', object.loader)

    const submit = document.createElement('button')
    submit.type = 'submit'
    submit.insertAdjacentHTML('beforeend', '<i class="vn-icons-search"></i>')

    input.addEventListener('input', (event) => {
      refine(event.target.value)
    })

    container.appendChild(navigation)
    container.appendChild(input)
    container.appendChild(submit)
  }

  container.querySelector('input').value = query
  container.querySelector('.vn-loader').hidden = !isSearchStalled
}

const customSearchBox = connectSearchBox(renderSearchBox)

const renderMenu = (renderOptions, isFirstRender) => {
  const { items, widgetParams } = renderOptions
  const container = document.querySelector(widgetParams.container)

  if (isFirstRender) {
    const ul = document.createElement('ul')

    container.appendChild(ul)
  }

  container.querySelector('ul').innerHTML = items
    .map((item) => {
      let url = ''
      let label = item.label

      if ('menu' === widgetParams.widget) {
        url = `${object.placesPage}?${placeSearchIndex}${encodeURI(
          `[${widgetParams.widget}][${widgetParams.attribute}]=${item.value}`
        )}`
      }

      if ('refinementList' === widgetParams.widget) {
        url = `${object.placesPage}?${placeSearchIndex}${encodeURI(
          `[${widgetParams.widget}][${widgetParams.attribute}][0]=${item.value}`
        )}`
      }

      return `
        <li>
          <a
            href="${url}"
            class="${widgetParams.itemClass}"
          >
            ${label}
          </a>
        </li>
      `
    })
    .join('')
}

const customMenu = connectMenu(renderMenu)

const checkLandingEl = document.querySelector('.landing-header-handler')
if ( checkLandingEl ) {
  landingHeaderSearch.addWidgets([
    customSearchBox({
      container: '.landing-header-handler',
      placeholder: __('Research...', 'vn'),
      showLoadingIndicator: false,
      classNames: {
        input: 'js-landing-header-input',
      },
    }),

    placeItems({
      container: '.landing-header-hits',
    }),

    configure({
      hitsPerPage: 4,
    }),

    index({
      indexName: locationSearchSuggestionsIndex,
    }).addWidgets([
      suggestionItems({
        container: '.landing-header-suggestions',
      }),
    ]),

    index({
      indexName: locationSearchIndex,
    }).addWidgets([
      locationItems({
        container: '.landing-header-locations',
      }),
    ]),

    index({
      indexName: placeSearchIndex,
    }).addWidgets([
      placeSmallItems({
        container: '.landing-header-places',
      }),
    ]),
  ])

  landingHeaderSearch.start()

  landingHeaderSearch.on('render', () => {
    const search = document.querySelector('.landing-header-handler')
    if (search) search.style.visibility = 'visible'
  })
}


function createLandingArchiveUrl(urlParams) {
  const formEL = document.querySelector('.js-landing-header-search-form')
  const urlEl = $('.js-landing-header-search-form').find('.all-places')
  const origUrl = urlEl.data('orig-href')
  let searchValue = ''
  if (  landingHeaderSearch.helper != null ) {
    searchValue = landingHeaderSearch.helper.getQuery().query
  }

  var finalUrl = origUrl

  if ( searchValue != undefined && searchValue != '' ) {
    finalUrl += object.placesQueryStrings.query + '/' + searchValue + '/'
  }

  if ( currentCategory != undefined ) {
    finalUrl += object.placesQueryStrings.placeCategory + '/' + currentCategory + '/'
  }

  urlEl.attr('href', finalUrl)
  formEL.setAttribute('action', finalUrl)

  return finalUrl
}

$('.js-landing-header-search-form').on('submit', function (e) {
  e.preventDefault()
  window.location.href = $(this).attr('action')
})

$(document).on('focus', '.header-search input[type=search]', function () {
  $('body').addClass('header-hero-search-active').css('overflow', 'hidden')
})

let canTriggerClose = true;
$(document).on('focus', '.js-landing-header-search-form input[type=search]', function () {
  $('body').addClass('hero-search-active');
  canTriggerClose = false;
  setTimeout(function() {
    canTriggerClose = true;
  }, 300);
});

$('.js-landing-header-search-form').on('click', function (e) {
  if (e.target === this && window.matchMedia('(min-width: 992px)').matches && canTriggerClose) {
    $('body').removeClass('hero-search-active');
  }
});

$('.js-close-algolia-mobile-landing-search').on('click', function(e) {
  e.preventDefault()
  $('body').removeClass('hero-search-active')
  unlockBody()
});

$(document).on(
  'click',
  '.landing-header-handler button[type=reset]',
  function () {
    $('body').removeClass('hero-search-active')
  }
)

document.addEventListener('DOMContentLoaded', function () {
  const checkHeaderLanding = document.querySelector('.header-landing')
  if ( checkHeaderLanding ) {
    var pageCategoryId = $('.header-landing').data('page-category')
    if ( landingHeaderSearch ) {
      landingHeaderSearch.helper.setQueryParameter('facets', ['placeCategory.ID']);
      landingHeaderSearch.helper.setQueryParameter('facetFilters', [['placeCategory.objectID:' + pageCategoryId]]);
      landingHeaderSearch.helper.search();


      currentCategory =  $('.header-landing').data('page-category-name')
    }
  }
});

export { landingHeaderSearch, createLandingArchiveUrl }